// extracted by mini-css-extract-plugin
export default {"customPicker":"DatePicker_customPicker__6b0dt"};